<template src="./ManualUpdateViaBrowser.html"></template>
<script lang="js">
import Vue from 'vue';
import {FileSizeFormatter} from "@/file-size-formatter";
import axios from "axios";
import {AnalyzeIdentifier} from "../../plugins/analyzeIdentifier";
import testdata from "@/components/manualupdate/testdata/browserDownloadResponse.json";


export default Vue.extend({
  name: 'nmouc-manual-update',
  data() {
    return {
      startDownloadSessionError: false,
      downloadFileListLoading: false,
      downloadFileList: {}
    }
  },
  computed: {
    outdatedRegions() {
      return this.$store.state.mapupdateInformation.mapRegions.filter(r => !r.upToDate);
    },
    selectedRegionCount() {
      return this.$store.state.manualUpdate.selectedRegions !== undefined ? this.$store.state.manualUpdate.selectedRegions.length : 0;
    },
    completeMapRegionCount() {
      if (this.shouldOfferFullInstall) {
        return this.$store.state.mapupdateInformation.mapRegions.length;
      } else {
        return this.outdatedRegions.length;
      }
    },
    selectedFileSize() {
      if (!this.$store.state.manualUpdate.completeMapSelected) {
        return this.fileSizeOfRegions(this.$store.state.manualUpdate.selectedRegions);
      } else {
        return this.fileSizeOfAllRegions;
      }
    },
    fileSizeOfAllRegions() {
      if (this.shouldOfferFullInstall) {
        return FileSizeFormatter.formatToGB(this.$store.state.mapupdateInformation.fullInstallDownloadSize);
      } else {
        return this.fileSizeOfRegions(this.outdatedRegions);
      }
    },
    isNoneRegionSelected() {
      return !(this.$store.state.manualUpdate.completeMapSelected || this.$store.state.manualUpdate.selectedRegions.length !== 0);
    },
    shouldOfferFullInstall() {
      return this.$store.state.mapupdateInformation.offerFullInstall
    },
    ntgFunctionalDuringUpdate() {
      return this.$store.state.mapupdateInformation.ntgFunctionalDuringUpdate
    },
    analyzeIdentifier() {
      return AnalyzeIdentifier.ID;
    },
    downloadFullInstall() {
      return this.shouldOfferFullInstall && this.$store.state.manualUpdate.completeMapSelected;
    },
    navigationUsableDuringInstallation() {
      return !this.downloadFullInstall;
    }
  },
  watch: {
    '$store.state.manualUpdate.step': function (step) {
      this.startDownloadSessionError = false;
      if (step === 3) {
        this.startDownloadSession()
      }
    }
  },
  methods: {
    close() {
      this.$store.commit('resetManualUpdateSelectedRegions')
      this.startDownloadSessionError = false;
      this.setStep(0)
    },
    setStep(step) {
      this.$store.commit("setManualUpdateStep", step)
    },
    setManualUpdateMode(mode) {
      this.$store.commit("setManualUpdateMode", mode)
    },
    startDownloadSession() {
      this.downloadFileList = {}
      this.downloadFileListLoading = true;
      // do not allow double submits
      this.startDownloadSessionError = false;
      if (process.env.VUE_APP_TESTDATA === "true") {
        if (process.env.VUE_APP_START_BROWSER_DOWNLOAD_ERROR === "true") {
          this.setStartDownloadSessionError()
        } else {
            this.downloadFileList = testdata;
        }
        this.downloadFileListLoading = false;
      } else {
        let ds;
        if (this.downloadFullInstall) {
          ds = this.createDownloadSessionFullInstall();
        } else {
          ds = this.createDownloadSession();
        }
        ds
          .then((response) => {
            this.downloadFileList = response.data
          })
          .catch((error) => {
            console.log('error', error);
            this.setStartDownloadSessionError()
          })
          .finally(() => {
            this.downloadFileListLoading = false;
          })
      }
    },
    createDownloadSession() {
      console.log("create Download Session")
      let regIdsForDownload = []
      if (this.$store.state.manualUpdate.completeMapSelected) {
        regIdsForDownload = this.getAllUpdatableRegIds();
      } else {
        regIdsForDownload = this.getSelectedRegIds();
      }
      return axios.post(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/maps`, regIdsForDownload,
          {
            withCredentials: true,
            params: {
              "isBrowserDownload": true,
            }
          },
      )
    },
    createDownloadSessionFullInstall() {
      return axios.post(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/maps/fullinstall`,
          {
            withCredentials: true,
            params: {
              "isBrowserDownload": true,
            }
          },
      )
    },
    getAllUpdatableRegIds() {
      return this.$store.state.mapupdateInformation.mapRegions
          .filter(r => !r.upToDate || !r.sdsUpToDate)
          .map(r => r.regId);
    },
    getSelectedRegIds() {
      let regIds = this.$store.state.manualUpdate.selectedRegions.map(r => r.regId);
      let otaRegion = this.$store.getters.getSelectedOtaRegion;
      if (this.shouldAddSdsForHomeRegion(otaRegion)) {
        regIds.push(otaRegion.regId)
      }
      return regIds;
    },
    updateCompleteMapSelected(completeMapSelected) {
      this.$store.commit('updateCompleteMapSelected', completeMapSelected)
    },
    calculateWbStepperStatus(step) {
      if (step < this.$store.state.manualUpdate.step) {
        return "done"
      }
      if (step > this.$store.state.manualUpdate.step) {
        return "disabled"
      }
      if (step === this.$store.state.manualUpdate.step) {
        return "default"
      }
    },
    fileSizeOfRegions(regions) {
      let size = 0
      for (var i = 0; i < regions.length; i++) {
        size += regions[i].fileSize + regions[i].sdsFileSize;
      }
      size += this.getExtraDataSize()
      return FileSizeFormatter.formatToGB(size);
    },
    getExtraDataSize() {
      let size = 524288000
      let otaRegion = this.$store.getters.getSelectedOtaRegion
      if (this.shouldAddSdsForHomeRegion(otaRegion)) {
        size += otaRegion.sdsFileSize
      }
      return size
    },
    shouldAddSdsForHomeRegion(otaRegion) {
      return otaRegion !== undefined && otaRegion.upToDate && !otaRegion.sdsUpToDate;
    },
    getUsbImagePath() {
      return this.$publicPath + "usbstick.svg"
    },
    setStartDownloadSessionError() {
      this.startDownloadSessionError = true
    },
    toggleRegion(region) {
      this.$store.commit('toggleManualUpdateSelectedRegion', region);
    },
    formatFileSize(size)  {
      const fileSizeInGB = this.formatToGB(size);
      if (fileSizeInGB >= 0.1) {
        return fileSizeInGB + " GB";
      }else  {
        const fileSizeInMB = this.formatToMB(size);
        if (fileSizeInMB >= 0.1) {
          return fileSizeInMB + " MB";
        }else {
          return this.formatToKB(size) + " KB";
        }
      }
    },
    formatToGB(size) {
      return FileSizeFormatter.formatToGB(size);
    },
    formatToMB(size) {
      return FileSizeFormatter.formatToMB(size);
    },
    formatToKB(size) {
      return FileSizeFormatter.formatToKB(size);
    }
  }
})
;
</script>
<style lang="scss" scoped>
.visited {
  color: #ADADAD !important;
}
</style>
